import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef, isValidElement, cloneElement } from 'react';
import system from '../../system';
import cx from 'classnames';
import Base from '../Base';
const SYSTEM_PROPS = ['colorProps', 'flexProps', 'marginProps', 'positioningProps', 'floatProps'];
const IconInternal = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    as,
    ...props
  } = _ref;
  const [className, style, rest] = system(props, SYSTEM_PROPS);
  const iconComponent = typeof as === 'function' ? as() : as;
  if (['function', 'object'].includes(typeof as) && iconComponent.$$typeof !== Symbol.for('react.forward_ref') && /*#__PURE__*/isValidElement(iconComponent)) {
    var _iconComponent$props;
    return /*#__PURE__*/cloneElement(iconComponent, {
      className: cx(className, (_iconComponent$props = iconComponent.props) == null ? void 0 : _iconComponent$props.className),
      style,
      ref,
      ...iconComponent.props,
      ...rest
    });
  }
  return /*#__PURE__*/React.createElement(Base, _extends({
    as: as,
    className: cx(className),
    style: style,
    ref: ref
  }, rest));
});
export default IconInternal;